<script lang="ts">
  import {
    paraphraseOptions,
    selectedText,
    userSignedIn,
    userData,
  } from "../store";
  import { deductCredits } from "../firebaseOperations";
  import { trackButtonClick } from "../utils";

  const paraphraseAPI = process.env.PARAPHRASE_API;
  let overlayText = "Please sign in!";

  async function handleClick() {
    if (!$userSignedIn) {
      return;
    }
    const paraButton = document.getElementById("paraButton");
    paraButton.innerHTML = "";

    const loadingText = document.createElement("div");
    loadingText.setAttribute("class", "loading-text");
    loadingText.innerText = "Coming soon!";
    paraButton.appendChild(loadingText);
    paraButton.style.fontSize = "medium";
    // let result = 0;
    // if (!$userData.admin || !$userData.premium) {
    //   result = await deductCredits($userData.id, 1);
    //   if (result === 0) {
    //     $userData.credits -= 1;
    //     overlayText = "Credits: " + $userData.credits;
    //   } else {
    //     if (result == 1) {
    //       overlayText = "Insufficient Credits";
    //       document.getElementById("paraButton").classList.add("grey-overlay");
    //     } else if (result == 2) {
    //       overlayText = "User does not exist!";
    //       document.getElementById("paraButton").classList.add("grey-overlay");
    //     } else if (result == 3) {
    //       overlayText = "Transaction error!";
    //       document.getElementById("paraButton").classList.add("grey-overlay");
    //     }
    //     setTimeout(() => {
    //       overlayText = "Cost: 1 Credit";
    //     }, 2000);
    //     paraButton.innerHTML = "Paraphrase";
    //     return;
    //   }
    // }
    // timeout and after 2 seconds, replace with the paraphrase innerhtml again. 
    setTimeout(() => {
      paraButton.innerHTML = "Paraphrase";
      paraButton.style.fontSize = "large";
    }, 2000);
    trackButtonClick("Paraphrase", 1);
    // paraphrase();
  }
  async function paraphrase() {
    const paraphraseAsync = async () => {
      try {
        const textArea = document.getElementById("input-textarea");
        $selectedText = textArea.value.substring(
          textArea.selectionStart,
          textArea.selectionEnd,
        );
        if ($selectedText.length > 5 && $selectedText.length < 100) {
          try {
            const response = await fetch(paraphraseAPI, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                text: $selectedText,
              }),
            });

            if (!response.ok) {
              throw new Error("Request failed");
            }

            const data = await response.json();
            const responseData = data["text"].split("+");
            if (responseData.length == 0) {
              responseData.push("No paraphrases found!");
            }
            $paraphraseOptions = responseData;
            // dispatch("success", responseData);
            document.getElementById("paraButton").innerHTML = "Success!";
            setTimeout(() => {
              document.getElementById("paraButton").innerHTML = "Paraphrase";
            }, 2000);
          } catch (error) {
            console.error(error);
          }
        }
        // Reset button to original state
      } catch (error) {
        console.error(error);
      }
    };
    setTimeout(paraphraseAsync, 250);
  }
  $: userSignedIn.subscribe((value) => {
    if (value) {
      overlayText = "Cost: 1 Credit";
    } else {
      overlayText = "Please sign in!";
    }
    if ($userData.premium || $userData.admin) {
      overlayText = "";
    }
  });
</script>

<div class="button-container">
  <button
    id="paraButton"
    class="button paraButton active-button"
    style="font-size:large"
    on:click={handleClick}
    class:grey-overlay={!$userSignedIn ||
      $selectedText.length < 5 ||
      $selectedText.length > 100}
  >
    Paraphrase
  </button>
  <div class="overlay-text">{overlayText}</div>
</div>